import { Request } from '../../httpClient/serverApi/requests/Request';

export interface IGetAdminProfileTemplateParams {
}

export interface IGetAdminProfileTemplateResult {
  permissions: Record<string, string[]>;
}

export class GetAdminProfileTemplateRequest extends Request<IGetAdminProfileTemplateParams, IGetAdminProfileTemplateResult> {
  constructor(params: IGetAdminProfileTemplateParams) {
    super('getAdminProfileTemplate', params);
  }
}
